import i18n from '../i18n';

export const formatTimeAgo = (dateStr: string): string => {
  const d = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  if (isNaN(d.getTime())) return '';

  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  // Convert to different units
  const diffSeconds = Math.ceil(diffMs / 1000);
  const diffMinutes = Math.ceil(diffSeconds / 60);
  const diffHours = Math.ceil(diffMinutes / 60);
  const diffDays = Math.ceil(diffHours / 24);
  const diffWeeks = Math.ceil(diffDays / 7);
  const diffMonths = Math.ceil(diffDays / 30);
  const diffYears = Math.ceil(diffDays / 365);

  const t = i18n.t.bind(i18n);

  // Determine the appropriate key and count
  if (diffSeconds < 30) {
    return t('time_ago.just_now', { ns: 'hub' });
  } else if (diffSeconds < 60) {
    return t('time_ago.seconds_ago', { count: diffSeconds, ns: 'hub' });
  } else if (diffMinutes === 1) {
    return t('time_ago.a_minute_ago', { ns: 'hub' });
  } else if (diffMinutes < 60) {
    return t('time_ago.minutes_ago', { count: diffMinutes, ns: 'hub' });
  } else if (diffHours === 1) {
    return t('time_ago.an_hour_ago', { ns: 'hub' });
  } else if (diffHours < 24) {
    return t('time_ago.hours_ago', { count: diffHours, ns: 'hub' });
  } else if (diffDays === 1) {
    return t('time_ago.a_day_ago', { ns: 'hub' });
  } else if (diffDays < 7) {
    return t('time_ago.days_ago', { count: diffDays, ns: 'hub' });
  } else if (diffWeeks === 1) {
    return t('time_ago.a_week_ago', { ns: 'hub' });
  } else if (diffWeeks < 4) {
    return t('time_ago.weeks_ago', { count: diffWeeks, ns: 'hub' });
  } else if (diffMonths === 1) {
    return t('time_ago.a_month_ago', { ns: 'hub' });
  } else if (diffMonths < 12) {
    return t('time_ago.months_ago', { count: diffMonths, ns: 'hub' });
  } else if (diffYears === 1) {
    return t('time_ago.a_year_ago', { ns: 'hub' });
  } else {
    return t('time_ago.years_ago', { count: diffYears, ns: 'hub' });
  }
};

/** Relative time plus exact date in locale (e.g. "Il y a 5 jours, 16 Janvier"). */
export const formatTimeAgoWithExactDate = (dateStr: string): string => {
  const relative = formatTimeAgo(dateStr);
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return relative;

  const now = new Date();
  const isSameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();

  if (isSameDay) {
    return relative;
  }

  const locale = i18n.language || 'fr';
  const isSameYear = d.getFullYear() === now.getFullYear();
  const options: Intl.DateTimeFormatOptions = isSameYear
    ? { day: 'numeric', month: 'long' }
    : { day: 'numeric', month: 'long', year: 'numeric' };
  const exact = d.toLocaleDateString(locale, options);
  return `${relative}, ${exact}`;
};
